import React, { useContext } from 'react'
import { VehicleContext } from '../Context/VehicleContext';
import { FeaturedVehileAccordionItem } from './FeaturedVehileAccordionItem';

const FeaturedVehicles = () => {
    
      const {getVehicleData, filteredVehicleData, searchText, setSearchText, numberFormatter, priceFormatter, inventoryManage} = useContext(VehicleContext);
        const handleSearchChange = (e) => {
            setSearchText(e.target.value.toLowerCase());
        };
  return (
    <>
        <section className='admin-common-wrap'>
            <div className='container'>
                <div className='admin-black-box'>
                    <div className='d-flex align-items-center justify-content-between mb-4'>
                        <div className='md-title font-1-8em text-uppercase'>SELECT FEATURED VEHICLES</div>
                        <div className='ad-search-block dash-search-block d-flex align-items-center'>
                            <input type='text' className='form-control' placeholder='Vehicle Search' value={searchText} onChange={handleSearchChange} />
                            <button className='dash-search-btn'>Search</button>
                        </div>
                    </div>
                    {/* <AdminAccordionItem
                        getVehicleData={getVehicleData}
                        // getVehicleDescriptions={getVehicleDescriptions}
                        filteredVehicleData={filteredVehicleData} 
                        numberFormatter={numberFormatter}
                        priceFormatter={priceFormatter}
                        vehicleDescriptionModify={vehicleDescriptionModify}
                    /> */}
                    <FeaturedVehileAccordionItem
                        getVehicleData={getVehicleData}
                        vehicleData={filteredVehicleData} 
                        numberFormatter={numberFormatter}
                        priceFormatter={priceFormatter}
                        inventoryManage={inventoryManage}
                    />
                </div>
            </div>
        </section>
    </>
  )
}

export default FeaturedVehicles